// Модуль попапа "Это моя компания"
app.modules.myCompany = (function (self) {
  var _wasSignedIn, _popup;

  function _showPopupOwnership(requestType, url) {
    $.ajax({
      type: requestType,
      url: url,
      dataType: 'html',
      error: function (jqXHR, textStatus, errorThrown) {
        window.console && console.log(jqXHR, textStatus, errorThrown);
      },
      success: function (result) {
        _disablePageScroll('hidden');
        const popupContent = document.createElement('div');
        popupContent.innerHTML = result;
        // Удаляем первый попап именно тут во избежание "моргания" при создании второго
        _removePopup();
        _popup = app.modules.modalDialog.create({
          content: popupContent,
          dialogClass: 'my-company-popup js-my-company-popup',
          close: function () {
            //если до этого не был авторизован, а сейчас авторизовался, то при закрытии попапа перезагрузимся
            !_wasSignedIn &&
              app.config.currentUser.email &&
              location.reload(true);
          },
        });
        if (!app.config.currentUser.email) {
          app.modules.staticAuthComponent.rerender();
        }
      },
    });
  }

  function _initAuthComponent() {
    app.config.authComponent.wrappers.static['my-company'] = {
      simpleRegistration: true,
      crossDomainAuth: app.config.crossDomainAuth,
      withSocialRegistration: false,
      orientation: 'vertical',
      containerName: 'myCompany',
      withoutSpinner: true,
      cache: false,
      fields: {
        set: ['email'],
        required: ['email'],
        hiddenByDefault: ['password'],
      },
    };
  }

  function _removePopup() {
    if (!_popup) return;
    _popup.close();
  }

  function _disablePageScroll(value) {
    const body = document.querySelector('.js-body');
    if (!body) {
      return;
    }
    body.style.overflow = value;
  }

  function onFormSubmit(event) {
    var $this = $(this);
    if (app.config.currentUser.email) {
      _showPopupOwnership('POST', $this.attr('action'));
    } else {
      app.modules.authComponent.processUserData.apply($this);
    }
    event.preventDefault();
  }

  function _listener() {
    $doc
      .on('click', '.js-my-company-link', function () {
        _showPopupOwnership('GET', $(this).data('href'));
      })
      .on('submit', '.js-my-company-form', onFormSubmit)
      .on('click', '.js-modal-dialog__close', function () {
        _disablePageScroll('');
      });
  }

  self.load = function () {
    //зафиксируем, потому что потом АК меняет на лету
    _wasSignedIn = app.config.currentUser.email || false;
    _wasSignedIn || _initAuthComponent();
    _listener();
  };

  return self;
})(app.modules.myCompany || {});
